"use client"

import { useState } from "react"
import "./Profile.css"

const Profile = () => {
  const [profile, setProfile] = useState({
    name: "Admin User",
    email: "admin@christlight.org",
    role: "Administrator",
    phone: "+234 123 456 7890",
    bio: "Dedicated administrator serving at Christ Light Assemblies.",
    joinDate: "2024-01-01",
  })

  const [isEditing, setIsEditing] = useState(false)
  const [editedProfile, setEditedProfile] = useState(profile)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setEditedProfile({
      ...editedProfile,
      [name]: value,
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setProfile(editedProfile)
    setIsEditing(false)
  }

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-cover"></div>
        <div className="profile-info">
          <div className="profile-avatar">
            <img src={require('../../images/Untitled.jpeg')} alt="Profile" />
            {!isEditing && (
              <button className="edit-avatar-btn" title="Change Profile Picture">
                <i className="material-icons">photo_camera</i>
              </button>
            )}
          </div>
          <div className="profile-details">
            <h1>{profile.name}</h1>
            <p className="profile-role">{profile.role}</p>
            <p className="profile-email">{profile.email}</p>
          </div>
        </div>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <div className="section-header">
            <h2>Personal Information</h2>
            {!isEditing ? (
              <button className="btn btn-secondary" onClick={() => setIsEditing(true)}>
                <i className="material-icons">edit</i>
                Edit Profile
              </button>
            ) : (
              <div className="edit-actions">
                <button className="btn btn-secondary" onClick={() => setIsEditing(false)}>
                  Cancel
                </button>
                <button className="btn" onClick={handleSubmit}>
                  Save Changes
                </button>
              </div>
            )}
          </div>

          <div className="profile-form">
            <div className="form-group">
              <label>Full Name</label>
              {isEditing ? (
                <input
                  type="text"
                  name="name"
                  value={editedProfile.name}
                  onChange={handleInputChange}
                  className="form-control"
                />
              ) : (
                <p>{profile.name}</p>
              )}
            </div>

            <div className="form-group">
              <label>Email</label>
              {isEditing ? (
                <input
                  type="email"
                  name="email"
                  value={editedProfile.email}
                  onChange={handleInputChange}
                  className="form-control"
                />
              ) : (
                <p>{profile.email}</p>
              )}
            </div>

            <div className="form-group">
              <label>Phone</label>
              {isEditing ? (
                <input
                  type="tel"
                  name="phone"
                  value={editedProfile.phone}
                  onChange={handleInputChange}
                  className="form-control"
                />
              ) : (
                <p>{profile.phone}</p>
              )}
            </div>

            <div className="form-group">
              <label>Bio</label>
              {isEditing ? (
                <textarea
                  name="bio"
                  value={editedProfile.bio}
                  onChange={handleInputChange}
                  className="form-control"
                  rows="4"
                />
              ) : (
                <p>{profile.bio}</p>
              )}
            </div>

            <div className="form-group">
              <label>Member Since</label>
              <p>{new Date(profile.joinDate).toLocaleDateString()}</p>
            </div>
          </div>
        </div>

        <div className="profile-section">
          <h2>Activity Summary</h2>
          <div className="activity-stats">
            <div className="stat-card">
              <i className="material-icons">campaign</i>
              <div className="stat-info">
                <h3>24</h3>
                <p>Announcements Posted</p>
              </div>
            </div>
            <div className="stat-card">
              <i className="material-icons">event</i>
              <div className="stat-info">
                <h3>12</h3>
                <p>Events Created</p>
              </div>
            </div>
            <div className="stat-card">
              <i className="material-icons">format_quote</i>
              <div className="stat-info">
                <h3>45</h3>
                <p>Quotes Added</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile 